export interface Blog {
	blogContentId:string;
	contentName?:string;
	blogEntries?:BlogEntry[];
    blogEntry?:BlogEntry;
}

export interface BlogEntry {
	contentId:string;
	contentName?:string;
	description?:string;
    articleContentId?:string;
    statusId?:string;
    imageContentId?:string;
    summaryContentId?:string;
    articleData?:string;		
}

export interface BlogState {
    blogs?:Blog[];
    selectedBlog?:Blog;
    blogEntries?:BlogEntry[];
    selectedBlogEntry?:BlogEntry;
	showFirstEntry?: boolean;
	useLocation?:boolean;
    callState?:CallState;
}

export enum LoadingState {
    INIT = "INIT",
    LOADING = "LOADING",
    LOADED = "LOADED"
}

export interface ErrorState {
    errorMsg: string;
}

export type CallState = LoadingState | ErrorState;